<template>
    <div :class="className" :style="{height:height,width:width}" />
  </template>
  <script>
  import * as echarts from 'echarts'
  import { debounce } from '@/utils'
  import { markRaw } from 'vue'
  export default {
    props: {
      className: {
        type: String,
        default: 'chart'
      },
      width: {
        type: String,
        default: '100%'
      },
      height: {
        type: String,
        default: '100%'
      },
      series:{
        type: Array,
         default: ()=>{
          return []
        }
      },
      name:{
        type:String,
        default:'变化幅度（mm）'
      }
    },
    data() {
      return {
        chart:null
      }
    },
    watch:{
      'series':{
        handler() {
           this.refreshData()
        },
        deep:true
      },
    },
    mounted() {
      this.refreshData()
      this.__resizeHandler = debounce(() => {
        if (this.chart) {
          this.chart.resize()
        }
      }, 500)
      window.addEventListener('resize', this.__resizeHandler)
    },
    beforeUnmount() {
      if (!this.chart) {
        return
      }
      window.removeEventListener('resize', this.__resizeHandler)
      this.chart.dispose()
      this.chart = null
    },
    methods: {
      initChart() {
          this.chart = markRaw(echarts.init(this.$el))
          this.setOption()
      },
      setOption(){
          this.chart.setOption({
            tooltip:{
              trigger: 'axis',
              axisPointer: {
              type: 'shadow' // 'shadow' as default; can also be 'line' or 'shadow'
              }
            },
            grid:{
                top:40,
                left:50,
                right:18,
                bottom:20,
            },
            xAxis: {
                type: 'time',
                boundaryGap: false,
                axisLabel:{
                    color:'#fff'
                }
            },
            yAxis: {
                name:this.name,
                nameTextStyle:{
                    color:'#fff'
                },
                type: 'value',
                splitLine:{
                    lineStyle:{
                        color:'#d1dbe547'
                    }
                },
                axisLabel:{
                    color:'#fff'
                },
                // splitLine:{
                //     show:false
                // }
            },
            series: this.series
          })
            
      },
      refreshData(){
          //刷新数据
          if(this.chart){
            this.setOption();  
          }else{
            this.initChart()
          }  
      }
    }
  }
  
  </script>